// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3663":"css/app.6947","4515":"css/admin-app.6947"}[chunkId] + ".css";
};